import {
  Component,
  Input,
  EventEmitter,
  Output
} from '@angular/core';

import { NbDialogService } from '@nebular/theme';

import { AutorizarTitularComponent }
  from '../autorizar-titular/autorizar-titular.component';

import { AskRolService } from '../../ask-rol.service';

@Component({
  selector: 'ngx-col-autorizacion-cue',

  template: `

    <span *ngIf="mostrarValor">
      {{ value }}
    </span>

    <button
      *ngIf="mostrarBoton"
      nbButton
      size="tiny"
      status="primary"
      (click)="autorizar()">

      AUTORIZAR

    </button>

  `,
})
export class ColAutorizacionCueComponent {

  @Input() value: any;

  @Input() rowData: any;

  @Input() esCompany = false;

  @Output() autorizacionRealizada =
    new EventEmitter<void>();

  constructor(
    private dialogService: NbDialogService,
    private askRolService: AskRolService
  ) {}

  /*
   * Devuelve true si la fila corresponde a un titular o si rolEntidad es vacío/null.
   */
  private esTitular(): boolean {

    const rol =
      (this.rowData?.rolEntidad || '')
        .toUpperCase()
        .trim();

    return rol === 'OWNER' || rol === '';
  }

  get mostrarValor(): boolean {

    /*
     * ADVISOR y WORKER no muestran nada.
     */
    if (!this.esTitular()) {
      return false;
    }

    /*
     * Si existe reaCueAuthorized mostramos su valor.
     */
    return !!this.value;
  }

  get mostrarBoton(): boolean {
    console.log(
      '[AUTORIZACION CUE]',
      {
        rowData: this.rowData,
        rolEntidad: this.rowData?.rolEntidad,
        value: this.value,
        esCompany: this.esCompany,
        esAdminEntidad: this.askRolService.esAdminEntidad,
        esSuperAdminEntidad: this.askRolService.esSuperAdminEntidad,
      }
    );
    /*
     * Solo administrador o superadministrador
     * de entidad.
     */
    if (
      !this.askRolService.esAdminEntidad &&
      !this.askRolService.esSuperAdminEntidad
    ) {
      return false;
    }

    /*
     * Solo titulares.
     *
     * OWNER, null, undefined o ''.
     */
    if (!this.esTitular()) {
      return false;
    }

    /*
     * Si ya existe autorización,
     * mostramos el valor y NO el botón.
     */
    if (this.value) {
      return false;
    }

    return true;
  }

  autorizar(): void {

    const dialogRef =
      this.dialogService.open(
        AutorizarTitularComponent,
        {
          context: {
            userData: this.rowData,
            esCompany: this.esCompany
          },

          closeOnBackdropClick: false,

          closeOnEsc: false,
        }
      );

    dialogRef.onClose.subscribe(
      (resultado: boolean) => {

        if (resultado === true) {
          this.autorizacionRealizada.emit();
        }

      }
    );
  }
}